module.exports = {
	"contractName": "UniversityFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_name",
					"type": "string"
				}
			],
			"name": "stringToBytes32",
			"outputs": [
				{
					"name": "name",
					"type": "bytes32"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405260008054600160a060020a03191633179055610a8c806100256000396000f30060806040526004361061006c5763ffffffff7c01000000000000000000000000000000000000000000000000000000006000350416637726f77681146100715780638da5cb5b146100a1578063cfb51928146100b6578063d38def5b14610121578063f2fde38b1461015c575b600080fd5b610085600160a060020a036004351661017f565b60408051600160a060020a039092168252519081900360200190f35b3480156100ad57600080fd5b50610085610376565b3480156100c257600080fd5b506040805160206004803580820135601f810184900484028501840190955284845261010f9436949293602493928401919081908401838280828437509497506103859650505050505050565b60408051918252519081900360200190f35b34801561012d57600080fd5b50610148600160a060020a03600435811690602435166103a4565b604080519115158252519081900360200190f35b34801561016857600080fd5b5061017d600160a060020a0360043516610435565b005b60006101896104c9565b6101c76040805190810160405280601a81526020017f4e6174696f6e616c2054616977616e20556e6976657273697479000000000000815250610385565b815260408051808201909152601d81527f4e6174696f6e616c205473696e672048756120556e6976657273697479000000602082015261020690610385565b60208083019190915260408051808201909152601d81527f4e6174696f6e616c2059616e67204d696e6720556e69766572736974790000009181019190915261024e90610385565b6040808301919091528051808201909152601e81527f4e6174696f6e616c204368656e67204b756e6720556e69766572736974790000602082015261029290610385565b606082015260408051808201909152601e81527f4e6174696f6e616c20436869616f2054756e6720556e6976657273697479000060208201526102d490610385565b608082015260408051808201909152601d81527f4e6174696f6e616c204368656e672043686920556e6976657273697479000000602082015261031690610385565b60a0820152806103246104e8565b808260c080838360005b8381101561034657818101518382015260200161032e565b50505050905001915050604051809103906000f08015801561036c573d6000803e3d6000fd5b5091505b50919050565b600054600160a060020a031681565b80516000908290151561039b5760009150610370565b50506020015190565b60008083905080600160a060020a031663c51157e06040518163ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401602060405180830381600087803b15801561040157600080fd5b505af1158015610415573d6000803e3d6000fd5b505050506040513d602081101561042b57600080fd5b5051949350505050565b600054600160a060020a0316331461044c57600080fd5b600160a060020a038116151561046157600080fd5b60008054604051600160a060020a03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff1916600160a060020a0392909216919091179055565b60c0604051908101604052806006906020820280388339509192915050565b604051610568806104f98339019056006000805460a060020a60ff02191690554260015560c0604052601e60808190527f4e6174696f6e616c20436869616f2054756e6720556e6976657273697479000060a09081526100529160029190610096565b5034801561005f57600080fd5b5060405160c0806105688339810160405260008054600160a060020a0319163217905561008f6003826006610114565b5050610161565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f106100d757805160ff1916838001178555610104565b82800160010185558215610104579182015b828111156101045782518255916020019190600101906100e9565b50610110929150610144565b5090565b8260068101928215610104579160200282015b828111156101045782518255602090920191600190910190610127565b61015e91905b80821115610110576000815560010161014a565b90565b6103f8806101706000396000f3006080604052600436106100775763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166316ada547811461007c5780638da5cb5b146100a35780639e03ba3c146100e1578063c51157e01461016b578063cfb5192814610194578063e8aab4d1146101ed575b600080fd5b34801561008857600080fd5b50610091610248565b60408051918252519081900360200190f35b3480156100af57600080fd5b506100b861024e565b6040805173ffffffffffffffffffffffffffffffffffffffff9092168252519081900360200190f35b3480156100ed57600080fd5b506100f661026a565b6040805160208082528351818301528351919283929083019185019080838360005b83811015610130578181015183820152602001610118565b50505050905090810190601f16801561015d5780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b34801561017757600080fd5b506101806102f5565b604080519115158252519081900360200190f35b3480156101a057600080fd5b506040805160206004803580820135601f81018490048402850184019095528484526100919436949293602493928401919081908401838280828437509497506103169650505050505050565b3480156101f957600080fd5b506040805160206004803580820135601f810184900484028501840190955284845261024694369492936024939284019190819084018382808284375094975061033a9650505050505050565b005b60015481565b60005473ffffffffffffffffffffffffffffffffffffffff1681565b6002805460408051602060018416156101000260001901909316849004601f810184900484028201840190925281815292918301828280156102ed5780601f106102c2576101008083540402835291602001916102ed565b820191906000526020600020905b8154815290600101906020018083116102d057829003601f168201915b505050505081565b60005474010000000000000000000000000000000000000000900460ff1681565b80516000908290151561032c5760009150610334565b602083015191505b50919050565b60005473ffffffffffffffffffffffffffffffffffffffff16331461035e57600080fd5b60055461036a82610316565b14156103aa576000805474ff00000000000000000000000000000000000000001916740100000000000000000000000000000000000000001790556103c9565b6000805474ff0000000000000000000000000000000000000000191690555b505600a165627a7a723058208e9f97f0a7192c81cd89ddec46d7f66630857c604a01dffad7a5d7cb740fbe5d0029a165627a7a7230582017d5cd2de4bc822084ef741f276f39fc80a6b67e7b8cf76b1f022f8583081ff80029",
	"deployedBytecode": "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",
	"sourceMap": "81:1007:25:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;81:1007:25;;;;;;",
	"deployedSourceMap": "81:1007:25:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;121:536;;-1:-1:-1;;;;;121:536:25;;;;;;;;;-1:-1:-1;;;;;121:536:25;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;858:228:25;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;858:228:25;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;858:228:25;;-1:-1:-1;858:228:25;;-1:-1:-1;;;;;;;858:228:25;;;;;;;;;;;;;;;;;661:193;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;661:193:25;-1:-1:-1;;;;;661:193:25;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;121:536:25;186:7;201:22;;:::i;:::-;239:45;;;;;;;;;;;;;;;;;;;:15;:45::i;:::-;229:55;;300:48;;;;;;;;;;;;;229:7;300:48;;;;;:15;:48::i;:::-;290:7;;;;:58;;;;364:48;;;;;;;;;;;;;;;;;;;;;;:15;:48::i;:::-;354:7;;;;:58;;;;428:49;;;;;;;;;;;;354:7;428:49;;;;;:15;:49::i;:::-;418:7;;;:59;493:49;;;;;;;;;;;;;418:7;493:49;;;;;:15;:49::i;:::-;483:7;;;:59;558:48;;;;;;;;;;;;;483:7;558:48;;;;;:15;:48::i;:::-;548:7;;;:58;:4;632:20;;:::i;:::-;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;632:20:25;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;632:20:25;625:27;;121:536;;;;;:::o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;858:228:25:-;982:10;;920:12;;965:5;;982:15;978:46;;;1014:3;;-1:-1:-1;1007:10:25;;978:46;-1:-1:-1;;1072:2:25;1061:14;1055:21;;1039:43::o;661:193::-;747:4;774:19;807:9;774:43;;830:8;-1:-1:-1;;;;;830:17:25;;:19;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;830:19:25;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;830:19:25;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;830:19:25;;661:193;-1:-1:-1;;;;661:193:25:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;81:1007:25:-;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;-1:-1;81:1007:25;;;-1:-1:-1;;81:1007:25:o;:::-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.18;\n\nimport \"./base/Level.sol\";\nimport \"./University.sol\";\n\ncontract UniversityFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    bytes32[6] memory data;\n    data[0] = stringToBytes32(\"National Taiwan University\");\n    data[1] = stringToBytes32(\"National Tsing Hua University\");\n    data[2] = stringToBytes32(\"National Yang Ming University\");\n    data[3] = stringToBytes32(\"National Cheng Kung University\");\n    data[4] = stringToBytes32(\"National Chiao Tung University\");\n    data[5] = stringToBytes32(\"National Cheng Chi University\");\n    _player;\n    return new University(data);\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    University instance = University(_instance);\n    return instance.combined();\n  }\n\n  function stringToBytes32(string memory _name) public returns (bytes32 name) {\n    bytes memory tmp = bytes(_name);\n\n    if (tmp.length == 0) {\n      return 0x0;\n    }\n\n    assembly {\n      name := mload(add(_name, 32))\n    }\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/UniversityFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/UniversityFactory.sol",
		"exportedSymbols": {
			"UniversityFactory": [
				2408
			]
		},
		"id": 2409,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2289,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:25"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 2290,
				"nodeType": "ImportDirective",
				"scope": 2409,
				"sourceUnit": 2867,
				"src": "26:26:25",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/University.sol",
				"file": "./University.sol",
				"id": 2291,
				"nodeType": "ImportDirective",
				"scope": 2409,
				"sourceUnit": 2288,
				"src": "53:26:25",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2292,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "111:5:25",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 2293,
						"nodeType": "InheritanceSpecifier",
						"src": "111:5:25"
					}
				],
				"contractDependencies": [
					2287,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2408,
				"linearizedBaseContracts": [
					2408,
					2866,
					2922
				],
				"name": "UniversityFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 2361,
							"nodeType": "Block",
							"src": "195:462:25",
							"statements": [
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 2304,
											"name": "data",
											"nodeType": "VariableDeclaration",
											"scope": 2362,
											"src": "201:22:25",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
												"typeString": "bytes32[6]"
											},
											"typeName": {
												"baseType": {
													"id": 2302,
													"name": "bytes32",
													"nodeType": "ElementaryTypeName",
													"src": "201:7:25",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												},
												"id": 2303,
												"length": {
													"argumentTypes": null,
													"hexValue": "36",
													"id": 2301,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "209:1:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													},
													"value": "6"
												},
												"nodeType": "ArrayTypeName",
												"src": "201:10:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_storage_ptr",
													"typeString": "bytes32[6]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2305,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "201:22:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2312,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2306,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "229:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2308,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2307,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "234:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "229:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c2054616977616e20556e6976657273697479",
													"id": 2310,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "255:28:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_1ff52df3cf5ac9abf85f43353fe45f92e537b8e1989f8bdb8351a5b71cc5d2c6",
														"typeString": "literal_string \"National Taiwan University\""
													},
													"value": "National Taiwan University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_1ff52df3cf5ac9abf85f43353fe45f92e537b8e1989f8bdb8351a5b71cc5d2c6",
														"typeString": "literal_string \"National Taiwan University\""
													}
												],
												"id": 2309,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "239:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2311,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "239:45:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "229:55:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2313,
									"nodeType": "ExpressionStatement",
									"src": "229:55:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2320,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2314,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "290:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2316,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2315,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "295:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "290:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c205473696e672048756120556e6976657273697479",
													"id": 2318,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "316:31:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_db09f65bf804b05e2558192b850f128c43061d34036ad6d237fb5aa963b092aa",
														"typeString": "literal_string \"National Tsing Hua University\""
													},
													"value": "National Tsing Hua University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_db09f65bf804b05e2558192b850f128c43061d34036ad6d237fb5aa963b092aa",
														"typeString": "literal_string \"National Tsing Hua University\""
													}
												],
												"id": 2317,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "300:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2319,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "300:48:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "290:58:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2321,
									"nodeType": "ExpressionStatement",
									"src": "290:58:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2328,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2322,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "354:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2324,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2323,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "359:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "354:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c2059616e67204d696e6720556e6976657273697479",
													"id": 2326,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "380:31:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_62f927fb60ece707bc770a4bd97b0d881fb3e7a80e22cfd1148d5e7e565c37e3",
														"typeString": "literal_string \"National Yang Ming University\""
													},
													"value": "National Yang Ming University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_62f927fb60ece707bc770a4bd97b0d881fb3e7a80e22cfd1148d5e7e565c37e3",
														"typeString": "literal_string \"National Yang Ming University\""
													}
												],
												"id": 2325,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "364:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2327,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "364:48:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "354:58:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2329,
									"nodeType": "ExpressionStatement",
									"src": "354:58:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2336,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2330,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "418:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2332,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2331,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "423:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "418:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c204368656e67204b756e6720556e6976657273697479",
													"id": 2334,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "444:32:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_9bead4c739aed0743fe75abc260bccf4c12c18f56333a654c22112d034eeb4b4",
														"typeString": "literal_string \"National Cheng Kung University\""
													},
													"value": "National Cheng Kung University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_9bead4c739aed0743fe75abc260bccf4c12c18f56333a654c22112d034eeb4b4",
														"typeString": "literal_string \"National Cheng Kung University\""
													}
												],
												"id": 2333,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "428:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2335,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "428:49:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "418:59:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2337,
									"nodeType": "ExpressionStatement",
									"src": "418:59:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2344,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2338,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "483:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2340,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2339,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "488:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "483:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c20436869616f2054756e6720556e6976657273697479",
													"id": 2342,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "509:32:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_fdba49c1e437ac80a7c615187b0fd0183e47bea6b9863cc282b9640b9845a224",
														"typeString": "literal_string \"National Chiao Tung University\""
													},
													"value": "National Chiao Tung University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_fdba49c1e437ac80a7c615187b0fd0183e47bea6b9863cc282b9640b9845a224",
														"typeString": "literal_string \"National Chiao Tung University\""
													}
												],
												"id": 2341,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "493:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2343,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "493:49:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "483:59:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2345,
									"nodeType": "ExpressionStatement",
									"src": "483:59:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2352,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2346,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "548:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2348,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 2347,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "553:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "548:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c204368656e672043686920556e6976657273697479",
													"id": 2350,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "574:31:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_026dc4812dd1d655d3d38290e3f98e97bfb9e51d511dc6908a105e0d2930b205",
														"typeString": "literal_string \"National Cheng Chi University\""
													},
													"value": "National Cheng Chi University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_026dc4812dd1d655d3d38290e3f98e97bfb9e51d511dc6908a105e0d2930b205",
														"typeString": "literal_string \"National Cheng Chi University\""
													}
												],
												"id": 2349,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "558:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2351,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "558:48:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "548:58:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2353,
									"nodeType": "ExpressionStatement",
									"src": "548:58:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2354,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2295,
										"src": "612:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2355,
									"nodeType": "ExpressionStatement",
									"src": "612:7:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2358,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "647:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											],
											"id": 2357,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "632:14:25",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_array$_t_bytes32_$6_memory_ptr_$returns$_t_contract$_University_$2287_$",
												"typeString": "function (bytes32[6] memory) returns (contract University)"
											},
											"typeName": {
												"contractScope": null,
												"id": 2356,
												"name": "University",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2287,
												"src": "636:10:25",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_University_$2287",
													"typeString": "contract University"
												}
											}
										},
										"id": 2359,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "632:20:25",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_University_$2287",
											"typeString": "contract University"
										}
									},
									"functionReturnParameters": 2299,
									"id": 2360,
									"nodeType": "Return",
									"src": "625:27:25"
								}
							]
						},
						"documentation": null,
						"id": 2362,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2296,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2295,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2362,
									"src": "145:15:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2294,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "145:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "144:17:25"
						},
						"payable": true,
						"returnParameters": {
							"id": 2299,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2298,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2362,
									"src": "186:7:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2297,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "186:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "185:9:25"
						},
						"scope": 2408,
						"src": "121:536:25",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2383,
							"nodeType": "Block",
							"src": "755:99:25",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2371,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2366,
										"src": "761:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2372,
									"nodeType": "ExpressionStatement",
									"src": "761:7:25"
								},
								{
									"assignments": [
										2374
									],
									"declarations": [
										{
											"constant": false,
											"id": 2374,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 2384,
											"src": "774:19:25",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_University_$2287",
												"typeString": "contract University"
											},
											"typeName": {
												"contractScope": null,
												"id": 2373,
												"name": "University",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2287,
												"src": "774:10:25",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_University_$2287",
													"typeString": "contract University"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2378,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2376,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2364,
												"src": "807:9:25",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2375,
											"name": "University",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2287,
											"src": "796:10:25",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_University_$2287_$",
												"typeString": "type(contract University)"
											}
										},
										"id": 2377,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "796:21:25",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_University_$2287",
											"typeString": "contract University"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "774:43:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 2379,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2374,
												"src": "830:8:25",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_University_$2287",
													"typeString": "contract University"
												}
											},
											"id": 2380,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "combined",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2205,
											"src": "830:17:25",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 2381,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "830:19:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2370,
									"id": 2382,
									"nodeType": "Return",
									"src": "823:26:25"
								}
							]
						},
						"documentation": null,
						"id": 2384,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2367,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2364,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2384,
									"src": "687:17:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2363,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "687:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2366,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2384,
									"src": "706:15:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2365,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "706:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "686:36:25"
						},
						"payable": false,
						"returnParameters": {
							"id": 2370,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2369,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2384,
									"src": "747:4:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2368,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "747:4:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "746:6:25"
						},
						"scope": 2408,
						"src": "661:193:25",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2406,
							"nodeType": "Block",
							"src": "934:152:25",
							"statements": [
								{
									"assignments": [
										2392
									],
									"declarations": [
										{
											"constant": false,
											"id": 2392,
											"name": "tmp",
											"nodeType": "VariableDeclaration",
											"scope": 2407,
											"src": "940:16:25",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes_memory_ptr",
												"typeString": "bytes"
											},
											"typeName": {
												"id": 2391,
												"name": "bytes",
												"nodeType": "ElementaryTypeName",
												"src": "940:5:25",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_storage_ptr",
													"typeString": "bytes"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2396,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2394,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2386,
												"src": "965:5:25",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											],
											"id": 2393,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "959:5:25",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
												"typeString": "type(bytes storage pointer)"
											},
											"typeName": "bytes"
										},
										"id": 2395,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "959:12:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes_memory",
											"typeString": "bytes memory"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "940:31:25"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2400,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2397,
												"name": "tmp",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2392,
												"src": "982:3:25",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											},
											"id": 2398,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "982:10:25",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2399,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "996:1:25",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "982:15:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2404,
									"nodeType": "IfStatement",
									"src": "978:46:25",
									"trueBody": {
										"id": 2403,
										"nodeType": "Block",
										"src": "999:25:25",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"hexValue": "307830",
													"id": 2401,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1014:3:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0x0"
												},
												"functionReturnParameters": 2390,
												"id": 2402,
												"nodeType": "Return",
												"src": "1007:10:25"
											}
										]
									}
								},
								{
									"externalReferences": [
										{
											"name": {
												"declaration": 2389,
												"isOffset": false,
												"isSlot": false,
												"src": "1047:4:25",
												"valueSize": 1
											}
										},
										{
											"_name": {
												"declaration": 2386,
												"isOffset": false,
												"isSlot": false,
												"src": "1065:5:25",
												"valueSize": 1
											}
										}
									],
									"id": 2405,
									"nodeType": "InlineAssembly",
									"operations": "{\n    name := mload(add(_name, 32))\n}",
									"src": "1030:56:25"
								}
							]
						},
						"documentation": null,
						"id": 2407,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "stringToBytes32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2387,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2386,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 2407,
									"src": "883:19:25",
									"stateVariable": false,
									"storageLocation": "memory",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 2385,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "883:6:25",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "882:21:25"
						},
						"payable": false,
						"returnParameters": {
							"id": 2390,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2389,
									"name": "name",
									"nodeType": "VariableDeclaration",
									"scope": 2407,
									"src": "920:12:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 2388,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "920:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "919:14:25"
						},
						"scope": 2408,
						"src": "858:228:25",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2409,
				"src": "81:1007:25"
			}
		],
		"src": "0:1089:25"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/UniversityFactory.sol",
		"exportedSymbols": {
			"UniversityFactory": [
				2408
			]
		},
		"id": 2409,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2289,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:25"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 2290,
				"nodeType": "ImportDirective",
				"scope": 2409,
				"sourceUnit": 2867,
				"src": "26:26:25",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/University.sol",
				"file": "./University.sol",
				"id": 2291,
				"nodeType": "ImportDirective",
				"scope": 2409,
				"sourceUnit": 2288,
				"src": "53:26:25",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2292,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "111:5:25",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 2293,
						"nodeType": "InheritanceSpecifier",
						"src": "111:5:25"
					}
				],
				"contractDependencies": [
					2287,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2408,
				"linearizedBaseContracts": [
					2408,
					2866,
					2922
				],
				"name": "UniversityFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 2361,
							"nodeType": "Block",
							"src": "195:462:25",
							"statements": [
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 2304,
											"name": "data",
											"nodeType": "VariableDeclaration",
											"scope": 2362,
											"src": "201:22:25",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
												"typeString": "bytes32[6]"
											},
											"typeName": {
												"baseType": {
													"id": 2302,
													"name": "bytes32",
													"nodeType": "ElementaryTypeName",
													"src": "201:7:25",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												},
												"id": 2303,
												"length": {
													"argumentTypes": null,
													"hexValue": "36",
													"id": 2301,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "209:1:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": null,
														"typeString": null
													},
													"value": "6"
												},
												"nodeType": "ArrayTypeName",
												"src": "201:10:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_storage_ptr",
													"typeString": "bytes32[6]"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2305,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "201:22:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2312,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2306,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "229:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2308,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2307,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "234:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "229:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c2054616977616e20556e6976657273697479",
													"id": 2310,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "255:28:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_1ff52df3cf5ac9abf85f43353fe45f92e537b8e1989f8bdb8351a5b71cc5d2c6",
														"typeString": "literal_string \"National Taiwan University\""
													},
													"value": "National Taiwan University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_1ff52df3cf5ac9abf85f43353fe45f92e537b8e1989f8bdb8351a5b71cc5d2c6",
														"typeString": "literal_string \"National Taiwan University\""
													}
												],
												"id": 2309,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "239:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2311,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "239:45:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "229:55:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2313,
									"nodeType": "ExpressionStatement",
									"src": "229:55:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2320,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2314,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "290:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2316,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2315,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "295:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "290:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c205473696e672048756120556e6976657273697479",
													"id": 2318,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "316:31:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_db09f65bf804b05e2558192b850f128c43061d34036ad6d237fb5aa963b092aa",
														"typeString": "literal_string \"National Tsing Hua University\""
													},
													"value": "National Tsing Hua University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_db09f65bf804b05e2558192b850f128c43061d34036ad6d237fb5aa963b092aa",
														"typeString": "literal_string \"National Tsing Hua University\""
													}
												],
												"id": 2317,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "300:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2319,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "300:48:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "290:58:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2321,
									"nodeType": "ExpressionStatement",
									"src": "290:58:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2328,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2322,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "354:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2324,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2323,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "359:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "354:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c2059616e67204d696e6720556e6976657273697479",
													"id": 2326,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "380:31:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_62f927fb60ece707bc770a4bd97b0d881fb3e7a80e22cfd1148d5e7e565c37e3",
														"typeString": "literal_string \"National Yang Ming University\""
													},
													"value": "National Yang Ming University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_62f927fb60ece707bc770a4bd97b0d881fb3e7a80e22cfd1148d5e7e565c37e3",
														"typeString": "literal_string \"National Yang Ming University\""
													}
												],
												"id": 2325,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "364:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2327,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "364:48:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "354:58:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2329,
									"nodeType": "ExpressionStatement",
									"src": "354:58:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2336,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2330,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "418:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2332,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 2331,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "423:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "418:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c204368656e67204b756e6720556e6976657273697479",
													"id": 2334,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "444:32:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_9bead4c739aed0743fe75abc260bccf4c12c18f56333a654c22112d034eeb4b4",
														"typeString": "literal_string \"National Cheng Kung University\""
													},
													"value": "National Cheng Kung University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_9bead4c739aed0743fe75abc260bccf4c12c18f56333a654c22112d034eeb4b4",
														"typeString": "literal_string \"National Cheng Kung University\""
													}
												],
												"id": 2333,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "428:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2335,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "428:49:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "418:59:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2337,
									"nodeType": "ExpressionStatement",
									"src": "418:59:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2344,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2338,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "483:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2340,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 2339,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "488:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "483:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c20436869616f2054756e6720556e6976657273697479",
													"id": 2342,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "509:32:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_fdba49c1e437ac80a7c615187b0fd0183e47bea6b9863cc282b9640b9845a224",
														"typeString": "literal_string \"National Chiao Tung University\""
													},
													"value": "National Chiao Tung University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_fdba49c1e437ac80a7c615187b0fd0183e47bea6b9863cc282b9640b9845a224",
														"typeString": "literal_string \"National Chiao Tung University\""
													}
												],
												"id": 2341,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "493:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2343,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "493:49:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "483:59:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2345,
									"nodeType": "ExpressionStatement",
									"src": "483:59:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2352,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2346,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "548:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											},
											"id": 2348,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 2347,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "553:1:25",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "548:7:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "4e6174696f6e616c204368656e672043686920556e6976657273697479",
													"id": 2350,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "574:31:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_026dc4812dd1d655d3d38290e3f98e97bfb9e51d511dc6908a105e0d2930b205",
														"typeString": "literal_string \"National Cheng Chi University\""
													},
													"value": "National Cheng Chi University"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_026dc4812dd1d655d3d38290e3f98e97bfb9e51d511dc6908a105e0d2930b205",
														"typeString": "literal_string \"National Cheng Chi University\""
													}
												],
												"id": 2349,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2407,
												"src": "558:15:25",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2351,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "558:48:25",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "548:58:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"id": 2353,
									"nodeType": "ExpressionStatement",
									"src": "548:58:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2354,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2295,
										"src": "612:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2355,
									"nodeType": "ExpressionStatement",
									"src": "612:7:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2358,
												"name": "data",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2304,
												"src": "647:4:25",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
													"typeString": "bytes32[6] memory"
												}
											],
											"id": 2357,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "632:14:25",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_array$_t_bytes32_$6_memory_ptr_$returns$_t_contract$_University_$2287_$",
												"typeString": "function (bytes32[6] memory) returns (contract University)"
											},
											"typeName": {
												"contractScope": null,
												"id": 2356,
												"name": "University",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2287,
												"src": "636:10:25",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_University_$2287",
													"typeString": "contract University"
												}
											}
										},
										"id": 2359,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "632:20:25",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_University_$2287",
											"typeString": "contract University"
										}
									},
									"functionReturnParameters": 2299,
									"id": 2360,
									"nodeType": "Return",
									"src": "625:27:25"
								}
							]
						},
						"documentation": null,
						"id": 2362,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2296,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2295,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2362,
									"src": "145:15:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2294,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "145:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "144:17:25"
						},
						"payable": true,
						"returnParameters": {
							"id": 2299,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2298,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2362,
									"src": "186:7:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2297,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "186:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "185:9:25"
						},
						"scope": 2408,
						"src": "121:536:25",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2383,
							"nodeType": "Block",
							"src": "755:99:25",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2371,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2366,
										"src": "761:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2372,
									"nodeType": "ExpressionStatement",
									"src": "761:7:25"
								},
								{
									"assignments": [
										2374
									],
									"declarations": [
										{
											"constant": false,
											"id": 2374,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 2384,
											"src": "774:19:25",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_University_$2287",
												"typeString": "contract University"
											},
											"typeName": {
												"contractScope": null,
												"id": 2373,
												"name": "University",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2287,
												"src": "774:10:25",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_University_$2287",
													"typeString": "contract University"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2378,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2376,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2364,
												"src": "807:9:25",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2375,
											"name": "University",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2287,
											"src": "796:10:25",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_University_$2287_$",
												"typeString": "type(contract University)"
											}
										},
										"id": 2377,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "796:21:25",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_University_$2287",
											"typeString": "contract University"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "774:43:25"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 2379,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2374,
												"src": "830:8:25",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_University_$2287",
													"typeString": "contract University"
												}
											},
											"id": 2380,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "combined",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2205,
											"src": "830:17:25",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 2381,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "830:19:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2370,
									"id": 2382,
									"nodeType": "Return",
									"src": "823:26:25"
								}
							]
						},
						"documentation": null,
						"id": 2384,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2367,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2364,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2384,
									"src": "687:17:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2363,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "687:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2366,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2384,
									"src": "706:15:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2365,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "706:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "686:36:25"
						},
						"payable": false,
						"returnParameters": {
							"id": 2370,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2369,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2384,
									"src": "747:4:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2368,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "747:4:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "746:6:25"
						},
						"scope": 2408,
						"src": "661:193:25",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2406,
							"nodeType": "Block",
							"src": "934:152:25",
							"statements": [
								{
									"assignments": [
										2392
									],
									"declarations": [
										{
											"constant": false,
											"id": 2392,
											"name": "tmp",
											"nodeType": "VariableDeclaration",
											"scope": 2407,
											"src": "940:16:25",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes_memory_ptr",
												"typeString": "bytes"
											},
											"typeName": {
												"id": 2391,
												"name": "bytes",
												"nodeType": "ElementaryTypeName",
												"src": "940:5:25",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_storage_ptr",
													"typeString": "bytes"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2396,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2394,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2386,
												"src": "965:5:25",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											],
											"id": 2393,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "959:5:25",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
												"typeString": "type(bytes storage pointer)"
											},
											"typeName": "bytes"
										},
										"id": 2395,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "959:12:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes_memory",
											"typeString": "bytes memory"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "940:31:25"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2400,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2397,
												"name": "tmp",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2392,
												"src": "982:3:25",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											},
											"id": 2398,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "982:10:25",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2399,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "996:1:25",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "982:15:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2404,
									"nodeType": "IfStatement",
									"src": "978:46:25",
									"trueBody": {
										"id": 2403,
										"nodeType": "Block",
										"src": "999:25:25",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"hexValue": "307830",
													"id": 2401,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1014:3:25",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0x0"
												},
												"functionReturnParameters": 2390,
												"id": 2402,
												"nodeType": "Return",
												"src": "1007:10:25"
											}
										]
									}
								},
								{
									"externalReferences": [
										{
											"name": {
												"declaration": 2389,
												"isOffset": false,
												"isSlot": false,
												"src": "1047:4:25",
												"valueSize": 1
											}
										},
										{
											"_name": {
												"declaration": 2386,
												"isOffset": false,
												"isSlot": false,
												"src": "1065:5:25",
												"valueSize": 1
											}
										}
									],
									"id": 2405,
									"nodeType": "InlineAssembly",
									"operations": "{\n    name := mload(add(_name, 32))\n}",
									"src": "1030:56:25"
								}
							]
						},
						"documentation": null,
						"id": 2407,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "stringToBytes32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2387,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2386,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 2407,
									"src": "883:19:25",
									"stateVariable": false,
									"storageLocation": "memory",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 2385,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "883:6:25",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "882:21:25"
						},
						"payable": false,
						"returnParameters": {
							"id": 2390,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2389,
									"name": "name",
									"nodeType": "VariableDeclaration",
									"scope": 2407,
									"src": "920:12:25",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 2388,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "920:7:25",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "919:14:25"
						},
						"scope": 2408,
						"src": "858:228:25",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2409,
				"src": "81:1007:25"
			}
		],
		"src": "0:1089:25"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.813Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/UniversityFactory.json
// module id = 1054
// module chunks = 0